import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_PRODUCTS](state, payload) {
    state.products = payload;
  },
  [MutationsType.SET_WAREHOUSES](state, payload) {
    state.warehouses = payload;
  },
  [MutationsType.ADD_WAREHOUSE](state, payload) {
    if (state.warehouses) state.warehouses.unshift(payload);
  },
  [MutationsType.SET_WAREHOUSES_STOCK_LOGS](state, payload) {
    state.stockLogs = payload;
  },
};
